import CssBaseline from '@mui/material/CssBaseline';
import 'moment/locale/pt-br';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './assets/fonts/Poppins/Poppins-Regular.ttf';
import { initPosthog } from './analytics/posthog';
import { ToastContainer } from './components';
import Routes from './routes';
import TagManager from './services/gtm';
import Theme from './styles/theme';

function App() {
  const tagManager = new TagManager();

  tagManager.initialize('GTM-TCR3HLV');

  useEffect(() => {
    // Carrega o PostHog logo no início para o `capture_exceptions` pegar os erros não tratados.
    initPosthog();
  }, []);

  return (
    <BrowserRouter>
      <Theme>
        <CssBaseline />
        <Routes />
        <ToastContainer autoClose={5000} position="bottom-center" />
      </Theme>
    </BrowserRouter>
  );
}
export default App;
